/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getApiKeys,
    getApiKey,
    printApiKey,
    createApiKeys,
    updateApiKeys,
    deleteApiKeys,
    getApiKeyHistory,
    getApiKeyHistoryParams,
    regenerateApiKey,
} from "Core/configuration/api_keys/config/api.api_keys";

const state = {
    page: {},
    api_key_history_page: {},
    form: {},
    api_keys: [],
    api_key_options: [],
    api_key_history: [],
    selectedApiKey: {
        api_keys_id: null,
        company_id: "",
        api_key_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        api_key_details: [],
    },
    api_keys_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_api_keys: {
        api_keys_id: {
            name: "api_keys_id",
            rules: "trim|integer|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|integer",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        api_key: {
            name: "api_key",
            rules: "trim|max_length[40]|required",
            max_len: "40",
            min_len: "",
            default_value: "",
        },
        corporate_id: {
            name: "corporate_id",
            rules: "trim|integer",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        level: {
            name: "level",
            rules: "trim|integer|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        user_id: {
            name: "user_id",
            rules: "trim|integer",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        api_key: {
            name: "api_key",
            rules: "trim|max_length[40]|required",
            max_len: "40",
            min_len: "",
            default_value: "",
        },
        ignore_limits: {
            name: "ignore_limits",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        api_secret: {
            name: "api_secret",
            rules: "trim|max_length[40]|required",
            max_len: "40",
            min_len: "",
            default_value: "",
        },
        is_private_key: {
            name: "is_private_key",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        ip_addresses: {
            name: "ip_addresses",
            rules: "trim",
            max_len: "2147483647",
            min_len: "",
            default_value: "",
        },
        max_requests_per_hour: {
            name: "max_requests_per_hour",
            rules: "trim|integer|required",
            max_len: "",
            min_len: "",
            default_value: "100",
        },
        max_requests_per_minute: {
            name: "max_requests_per_minute",
            rules: "trim|integer|required",
            max_len: "",
            min_len: "",
            default_value: "100",
        },
        level: {
            name: "level",
            rules: "trim|integer|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        app_name: {
            name: "app_name",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ignore_limits: {
            name: "ignore_limits",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        is_private_key: {
            name: "is_private_key",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        ip_addresses: {
            name: "ip_addresses",
            rules: "trim",
            max_len: "2147483647",
            min_len: "",
            default_value: "",
        },
        app_name: {
            name: "app_name",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        disabled: {
            name: "disabled",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    api_keys: (state) => {
        return state.api_keys;
    },
    api_key_history: (state) => {
        return state.api_key_history;
    },
    api_key_history_page: (state) => {
        return state.api_key_history;
    },
};

// actions
const actions = {
    async fetchApiKeys({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getApiKeys({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "api_key_options",
                        with: response.data.api_keys,
                    });
                } else {
                    commit("mutate", {
                        property: "api_keys",
                        with: response.data.api_keys,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchApiKey({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getApiKey(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedApiKey",
                    with: response.data.api_key,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async reKeyApiKey({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await regenerateApiKey(payload.id, body);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedApiKey",
                    with: response.data.api_key,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async fetchApiKeyHistory({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getApiKeyHistory({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "api_key_history_page",
                        with: response.data.page,
                    });
                }
                commit("mutate", {
                    property: "api_key_history",
                    with: response.data.api_rest_logs,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async fetchApiKeyHistoryParams({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getApiKeyHistoryParams(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log(error);
            console.log("fetch single error");
            return;
        }
    },
    async printApiKey({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printApiKey(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveApiKey({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["api_keys_id"] === "undefined" || body["api_keys_id"] == null || body["api_keys_id"] == "") {
                delete body["api_keys_id"];
                response = await createApiKeys({ body: body, headers: config.headers });
            } else {
                let api_keys_id = body["api_keys_id"];
                delete body["api_keys_id"];
                response = await updateApiKeys({ body: body, headers: config.headers }, api_keys_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteApiKey({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteApiKeys(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
